"use strict";

// "use strict";
jQuery(document).ready(function ($) {
  // Text rotation functionality
  function initTextRotation() {
    var textItems = $('.campaign-header .mask > span');
    var currentIndex = 0;
    var isAnimating = false;

    // Show the first item initially
    $(textItems[currentIndex]).addClass('active');

    // Set interval to rotate text
    setInterval(function () {
      if (isAnimating) return;
      isAnimating = true;

      // Hide current item and animate it upward
      $(textItems[currentIndex]).removeClass('active').addClass('exiting');

      // Wait for exit animation to complete before showing next item
      setTimeout(function () {
        // Remove the exiting class
        $(textItems[currentIndex]).removeClass('exiting');

        // Move to next item (or back to first)
        currentIndex = (currentIndex + 1) % textItems.length;

        // Show new item
        $(textItems[currentIndex]).addClass('active');
        isAnimating = false;
      }, 300); // Match this to the CSS transition duration
    }, 4200); // 4200ms between changes
  }
  function initCarousel() {
    // Initialize separate carousels for mobile and desktop
    var mobileCarouselItems = $('.carousel.mobile .carousel-item');
    var desktopCarouselItems = $('.carousel.desktop .carousel-item');
    var mobileCurrentIndex = 0;
    var desktopCurrentIndex = 0;

    // Set interval to rotate carousels
    setInterval(function () {
      // Update mobile carousel
      $(mobileCarouselItems[mobileCurrentIndex]).removeClass('active');
      mobileCurrentIndex = (mobileCurrentIndex + 1) % mobileCarouselItems.length;
      $(mobileCarouselItems[mobileCurrentIndex]).addClass('active');

      // Update desktop carousel (synchronized with mobile)
      $(desktopCarouselItems[desktopCurrentIndex]).removeClass('active');
      desktopCurrentIndex = (desktopCurrentIndex + 1) % desktopCarouselItems.length;
      $(desktopCarouselItems[desktopCurrentIndex]).addClass('active');
    }, 4200); // 4200ms between changes
  }

  // Initialize text rotation and carousel
  initTextRotation();
  initCarousel();
});